import React from "react";
import { useParams } from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import { useState } from "react";
import { apiPath } from "../../utility/Constant";
import { useEffect } from "react";
import GlobalForm from "../../components/globalForm/GlobalForm";
import { updateData } from "../../hooks/update";

function CsrHighlightpage() {
  const { CSRApi } = apiPath;
  const { id } = useParams();
  const [csrData, uloading] = useFetch(CSRApi, true);
  const [filteredData, setFilteredData] = useState({});

  useEffect(() => {
    const filtereddata = [...csrData].filter(
      (item) => item.slug === "highlight"
    );
    setFilteredData(filtereddata);
  }, [csrData]);

  const { contactBgImg, contactSubTitle, contactTitle, _id } =
    filteredData ?? {};

  const data = [
    {
      elementType: "file",
      label: "Contact Background Image",
      type: "text",
      name: "contactBgImg",
      defaultValue: contactBgImg,
      required: true,
    },
    {
      elementType: "textField",
      label: "Contact Title",
      type: "text",
      name: "contactTitle",
      defaultValue: contactTitle,
      required: true,
    },
    {
      elementType: "textField",
      label: "Contact Subtitle",
      type: "text",
      name: "contactSubTitle",
      defaultValue: contactSubTitle,
      required: true,
    },
  ];

  const update = (data) => {
    updateData(`${CSRApi}/${_id}`, data, true);
  };

  return <div>{_id && <GlobalForm data={data} update={update} />}</div>;
}

export default CsrHighlightpage;
